// extracted by mini-css-extract-plugin
module.exports = {"page":"auth_page__JdHDa","hr":"auth_hr__nG_l1","actionContainer":"auth_actionContainer__Z056n","card":"auth_card__wMgZR"};